import type { ReactNode } from "react";

interface SectionHeadingProps {
  kicker: string;
  title: string;
  desc?: string;
  side?: ReactNode;
}

export default function SectionHeading({ kicker, title, desc, side }: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between md:gap-8">
      <div className="max-w-2xl">
        <span className="inline-flex items-center gap-2 font-label text-xs tracking-[0.3em] text-primary-600">
          <span className="inline-block h-px w-8 bg-primary-500" />
          {kicker}
        </span>
        <h2 className="mt-4 font-heading text-3xl font-bold leading-snug md:text-4xl">
          {title}
        </h2>
        {desc ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
            {desc}
          </p>
        ) : null}
      </div>
      {side ? <div className="shrink-0">{side}</div> : null}
    </div>
  );
}